import { Card, Col, Drawer, Row, Spin } from 'antd';
import { useUnit } from 'effector-react';
import MapBlock from '../../components/MapBlock/MapBlock.jsx';
import CenterHomeFilters from '../../components/CenterHomeFilters/CenterHomeFilters.jsx';
import CenterHomePopup from '../../components/CenterHomePopup/CenterHomePopup.jsx';
import CenterHomeMobilePopup from '../../components/CenterHomePopup/CenterHomeMobilePopup.jsx';
import {
  getCHHexagonsFx,
  getCHPointsFx,
} from '../../models/centerHomeModel/index.js';

function CenterHome() {
  const pointsPending = useUnit(getCHPointsFx.pending);
  const hexPending = useUnit(getCHHexagonsFx.pending);

  const loading = pointsPending || hexPending;

  return (
    <Spin spinning={loading}>
      <div
        style={{
          width: '100%',
          maxWidth: '1120px',
          margin: '0 auto',
          height: '100%',
        }}
      >
        <Row gutter={[20, 0]} style={{ height: '100%' }}>
          <Col style={{ width: '100%' }}>
            <CenterHomeFilters />
            <Card
              className="map_card"
              style={{ height: 720 }}
              bodyStyle={{ height: '100%' }}
            >
              <MapBlock />
            </Card>
            <CenterHomeMobilePopup />
          </Col>
        </Row>
      </div>
    </Spin>
  );
}

export default CenterHome;
